<div class="content-card">
<div class="card-inner">
  <div class="font-semibold text-xl module-name mb-4">
    Execution Results
  </div>

<!-- FILTER BAR -->
<div class="filter-bar">
  <!-- Row 1: Client, Tenant, Package, Test Type, Functional Area -->
  <div class="filter-row">
    <div class="filter-item">
      <label class="filter-label">Client</label>
      <p-select [options]="viewModel.clientOptions()"
        (onChange)="viewModel.onClientFilterChange($event.value)"
        [ngModel]="viewModel.selectedClientFilter()"
        [disabled]="viewModel.isClientDropdownDisabled()" optionLabel="label" optionValue="value"
        placeholder="Filter by Client" [showClear]="!!viewModel.selectedClientFilter()"
        (onClear)="viewModel.clearClientFilter()" [filter]="true" filterBy="label"
        styleClass="w-full dropdown-sm">
      </p-select>
    </div>
    <div class="filter-item">
      <label class="filter-label">Tenant</label>
      <p-select [options]="viewModel.tenantOptions()"
        [ngModel]="viewModel.selectedTenantId()"
        (ngModelChange)="viewModel.onTenantFilterChange($event)"
        optionLabel="label" optionValue="value"
        placeholder="Select Tenant" [showClear]="!!viewModel.selectedTenantId()"
        (onClear)="viewModel.clearTenantFilter()"
        [filter]="true" filterBy="label" styleClass="w-full dropdown-sm"
        [appendTo]="'body'">
      </p-select>
    </div>
    <div class="filter-item">
      <label class="filter-label">Package</label>
      <p-select [options]="viewModel.packageOptions"
        [ngModel]="viewModel.selectedPackageId()" (ngModelChange)="viewModel.onPackageFilterChange($event)"
        (onClear)="viewModel.clearPackageFilter()"
        optionLabel="packageName" optionValue="id" placeholder="Select Package"
        [disabled]="!viewModel.selectedClientFilter()" [showClear]="!!viewModel.selectedPackageId()"
        [filter]="true" filterBy="packageName" styleClass="w-full dropdown-sm"
        [appendTo]="'body'">
      </p-select>
    </div>
    <div class="filter-item">
      <label class="filter-label">Test Type</label>
      <p-multiSelect [options]="viewModel.testTypeFilterOptions()"
        [ngModel]="viewModel.selectedTestTypeIds()"
        (onChange)="viewModel.filterByTestType($event.value)"
        (onClear)="viewModel.clearTestTypeFilter()" optionLabel="label" optionValue="value"
        placeholder="Select Test Types" [filter]="true"
        [showClear]="viewModel.selectedTestTypeIds().length > 0" display="chip"
        [maxSelectedLabels]="1" styleClass="w-full dropdown-sm">
      </p-multiSelect>
    </div>
    <div class="filter-item">
      <label class="filter-label">Functional Area</label>
      <p-multiSelect [options]="viewModel.functionalAreaOptions()"
        [ngModel]="viewModel.selectedFunctionalAreaIds()"
        (onChange)="viewModel.onPackageChange($event.value)"
        (onClear)="viewModel.clearFunctionalAreaFilter()" optionLabel="displayLabel"
        optionValue="id" placeholder="Select Areas"
        [disabled]="!viewModel.selectedClientFilter() || viewModel.selectedTestTypeIds().length === 0"
        [showClear]="true" [filter]="true" filterBy="name" styleClass="w-full dropdown-sm" display="chip"
        [maxSelectedLabels]="1" dataKey="id" [appendTo]="'body'">
      </p-multiSelect>
    </div>
  </div>
  <!-- Row 2: Scenario, Status, Date Range, Buttons -->
  <div class="filter-row">
    <div class="filter-item">
      <label class="filter-label">Scenario</label>
      <p-multiSelect [options]="viewModel.scenarios()"
        [ngModel]="viewModel.selectedScenario()" (ngModelChange)="viewModel.onScenarioChange($event)"
        (onClear)="viewModel.clearScenarioFilter()"
        optionLabel="scenarioName" optionValue="id" placeholder="Select Scenarios"
        [disabled]="viewModel.selectedFunctionalAreaIds().length === 0" [showClear]="true"
        [filter]="true" filterBy="scenarioName" styleClass="w-full dropdown-sm" display="chip"
        [maxSelectedLabels]="1" dataKey="id">
      </p-multiSelect>
    </div>
    <div class="filter-item">
      <label class="filter-label">Status</label>
      <p-select [options]="viewModel.getTestStatusOptions()"
        [(ngModel)]="viewModel.filterStatus" optionLabel="value" optionValue="id"
        placeholder="Select Status" [showClear]="!!viewModel.filterStatus"
        (onClear)="viewModel.onStatusFilterClear()" styleClass="w-full dropdown-sm">
      </p-select>
    </div>
    <div class="filter-item">
      <label class="filter-label">Date Range</label>
      <p-datepicker [ngModel]="viewModel.dateRange()" (ngModelChange)="viewModel.dateRange.set($event)"
        selectionMode="range" placeholder="Select date range" dateFormat="dd/mm/yy" [showIcon]="true"
        [readonlyInput]="true" [showClear]="false" [maxDate]="viewModel.maxDate" styleClass="w-full dropdown-sm">
      </p-datepicker>
    </div>
    <div class="filter-buttons">
      <p-button label="Search" (onClick)="viewModel.onApplyFilters()"
        [disabled]="!viewModel.dateRange() || !viewModel.selectedClientFilter()"
        styleClass="btn-search"></p-button>
      <p-button label="Reset" (onClick)="viewModel.onResetFilters()" severity="secondary"
        [disabled]="!viewModel.hasActiveFilters()" styleClass="btn-reset"></p-button>
    </div>
  </div>
</div>

<!-- FA TABS (full width, above split layout) -->
<div class="fa-tabs-full">
  @for (fa of viewModel.functionalAreaTabs(); track fa.id) {
    <button class="fa-tab" [class.active]="viewModel.selectedFaTabId() === fa.id"
            (click)="viewModel.onFaTabChange(fa.id)">
      {{ fa.name }} <span class="fa-count">{{ fa.scenarioCount }}</span>
    </button>
  }
</div>

<!-- SPLIT LAYOUT (below FA tabs) -->
<div class="split-layout" style="border-top: none; border-radius: 0 0 8px 8px;">

  <!-- LEFT PANEL: Scenario List -->
  <div class="left-panel">
    <div class="left-header">
      <span class="left-title">Scenarios</span>
      <span class="left-count">{{ viewModel.totalScenarios() }} results</span>
    </div>

    <!-- Scenario search -->
    <div class="left-search">
      <input pInputText placeholder="Filter scenarios..."
             [(ngModel)]="viewModel.scenarioSearchText"
             (input)="viewModel.onScenarioSearchChange($any($event.target).value)" />
    </div>

    <!-- Scenario list -->
    <div class="scenario-list">
      @if (viewModel.isLoadingScenarios()) {
        <div class="loading-state">
          <i class="pi pi-spin pi-spinner"></i>
          <span>Loading...</span>
        </div>
      } @else if (viewModel.filteredScenarioSummaries().length === 0) {
        <div class="empty-state">No scenarios found</div>
      } @else {
        @for (sc of viewModel.filteredScenarioSummaries(); track (sc.executionRunId || sc.scenarioId)) {
          <div class="scenario-item"
               [class.selected]="sc.executionRunId ? viewModel.selectedExecutionRunId() === sc.executionRunId : (viewModel.selectedScenarioId() === sc.scenarioId && viewModel.selectedScenarioData()?.latestStartedAt === sc.latestStartedAt)"
               (click)="viewModel.onScenarioSelect(sc.scenarioId, sc.executionRunId)">
            <div class="sc-dot" [class.pass]="sc.failed === 0 && sc.stopped === 0"
                 [class.fail]="sc.failed > 0" [class.stop]="sc.failed === 0 && sc.stopped > 0"></div>
            <div class="sc-info">
              <div class="sc-name">{{ sc.scenarioName || sc.scenarioId }}</div>
              <div class="sc-meta">
                <span>{{ sc.totalSteps }} steps</span>
                @if (sc.passed > 0) { <span class="badge badge-pass">{{ sc.passed }}P</span> }
                @if (sc.failed > 0) { <span class="badge badge-fail">{{ sc.failed }}F</span> }
                @if (sc.stopped > 0) { <span class="badge badge-stop">{{ sc.stopped }}S</span> }
                <span class="sc-time">{{ sc.latestStartedAt | date:'MM/dd/yyyy hh:mm a' }}</span>
              </div>
              @if (sc.executedByName) {
                <div class="sc-executed-by">
                  <i class="pi pi-user"></i> {{ sc.executedByName }}
                </div>
              }
              @if (sc.tenantName) {
                <div class="sc-tenant">
                  <i class="pi pi-globe"></i> {{ sc.tenantName }}
                </div>
              }
            </div>
          </div>
        }
      }
    </div>

    <!-- Mini paginator -->
    <p-paginator [rows]="viewModel.pageSize()" [totalRecords]="viewModel.totalScenarios()"
                 [first]="viewModel.currentPage() * viewModel.pageSize()"
                 [rowsPerPageOptions]="[10, 20, 50]"
                 (onPageChange)="viewModel.onScenarioPageChange($event)"
                 [showCurrentPageReport]="true"
                 currentPageReportTemplate="{first}-{last} of {totalRecords}"
                 styleClass="paginator-mini">
    </p-paginator>
  </div>

  <!-- RIGHT PANEL: Step Details -->
  <div class="right-panel">
    @if (!viewModel.selectedScenarioId()) {
      <div class="empty-right">
        <i class="pi pi-list" style="font-size: 2rem;"></i>
        <span>Select a scenario to view execution steps</span>
      </div>
    } @else {
      <!-- Scenario header -->
      <div class="right-header">
        <div class="rh-top">
          <div class="rh-title">{{ viewModel.selectedScenarioName() }}</div>
          <div class="rh-stats">
            <span>{{ viewModel.selectedScenarioSteps().length }} Steps</span>
            <span class="stat-pass">{{ viewModel.selectedScenarioPassed() }} Passed</span>
            <span class="stat-fail">{{ viewModel.selectedScenarioFailed() }} Failed</span>
            <span class="stat-stop">{{ viewModel.selectedScenarioStopped() }} Stopped</span>
          </div>
        </div>
        @if (viewModel.selectedScenarioData()?.scenarioDescription) {
          <div class="rh-desc">{{ viewModel.selectedScenarioData().scenarioDescription }}</div>
        }
        <div class="rh-sub">
          <span><i class="pi pi-folder"></i> {{ viewModel.selectedFaName() }}</span>
          <span><i class="pi pi-calendar"></i> {{ viewModel.selectedScenarioDate() }}</span>
          @if (viewModel.selectedScenarioData()?.executedByName) {
            <span><i class="pi pi-user"></i> {{ viewModel.selectedScenarioData().executedByName }}</span>
          }
        </div>
      </div>

      <!-- Progress bar -->
      @if (viewModel.selectedScenarioData()?.totalSteps > 0) {
        <div class="progress-bar">
          @if (viewModel.selectedScenarioPassed() > 0) {
            <div class="pb-p"
                 [style.width.%]="(viewModel.selectedScenarioPassed() / viewModel.selectedScenarioData().totalSteps) * 100">
            </div>
          }
          @if (viewModel.selectedScenarioFailed() > 0) {
            <div class="pb-f"
                 [style.width.%]="(viewModel.selectedScenarioFailed() / viewModel.selectedScenarioData().totalSteps) * 100">
            </div>
          }
          @if (viewModel.selectedScenarioStopped() > 0) {
            <div class="pb-s"
                 [style.width.%]="(viewModel.selectedScenarioStopped() / viewModel.selectedScenarioData().totalSteps) * 100">
            </div>
          }
        </div>
      }

      <!-- Steps container -->
      <div class="step-container">
        @if (viewModel.isLoadingSteps()) {
          <div class="loading-state">
            <i class="pi pi-spin pi-spinner"></i>
            <span>Loading steps...</span>
          </div>
        } @else {
          @for (step of viewModel.scenarioSteps(); track step.id; let i = $index) {
            <!-- Step row -->
            <div class="step-row" [class.expanded]="viewModel.expandedStepId() === step.id"
                 (click)="viewModel.onStepExpand(step.id)">
              <span class="sn" [class.ok]="step.stepStatus === 'success'"
                    [class.err]="step.stepStatus === 'failed'"
                    [class.skip]="step.stepStatus === 'stopped'">{{ i + 1 }}</span>
              <span class="sd">{{ step.testDescription }}</span>
              <span class="sa">{{ step.parsedAction }}</span>
              <!-- <span class="st">{{ step.parsedDuration }}</span> -->
              <span class="ss" [class.ok]="step.stepStatus === 'success'"
                    [class.err]="step.stepStatus === 'failed'"
                    [class.skip]="step.stepStatus === 'stopped'">
                {{ step.stepStatus === 'success' ? 'Passed' : step.stepStatus === 'failed' ? 'Failed' : step.stepStatus === 'stopped' ? 'Stopped' : '-' }}
              </span>
              @if (step.screenshotUrl) {
                <img class="simg" [src]="step.screenshotFullUrl" alt="screenshot"
                     (click)="viewModel.viewScreenshot(step.screenshotUrl); $event.stopPropagation()" />
              } @else {
                <div class="simg">-</div>
              }
              <i class="pi pi-chevron-right schv"></i>
            </div>

            <!-- Expanded detail (MATCHES EXISTING LOG DISPLAY EXACTLY) -->
            @if (viewModel.expandedStepId() === step.id) {
              <div class="step-detail">
                <div class="detail-grid">
                  <div class="detail-left">
                    <div class="section-title"><i class="pi pi-list"></i> Log Details</div>
                    <div style="font-size: 12px; font-family: monospace; max-height: 280px; overflow-y: auto; background: #f8f9fa; padding: 8px; border-radius: 4px;">
                      <ng-container *ngIf="step.logText; else noLogText">
                        <ng-container *ngIf="viewModel.parseLogText(step.logText) as logData; else parseError">
                          <!-- Action & Description -->
                          <div style="margin-bottom: 8px; padding: 8px; background: white; border-radius: 4px; border-left: 3px solid #3b82f6;">
                            <div style="font-weight: 600; color: #1f2937; margin-bottom: 4px;">
                              <i class="pi pi-info-circle" style="margin-right: 4px; color: #3b82f6;"></i>
                              Action: {{ logData.action }}
                            </div>
                            <div style="color: #4b5563; margin-bottom: 4px;">{{ logData.description }}</div>
                            <div style="display: flex; gap: 12px; color: #6b7280; font-size: 11px;">
                              <span><strong>Success:</strong> {{ logData.result?.success ? 'Yes' : 'No' }}</span>
                              <span><strong>Passed:</strong> {{ logData.passed ? 'Yes' : 'No' }}</span>
                            </div>
                          </div>

                          <!-- Assertion Details -->
                          <ng-container *ngIf="logData.result?.result?.assertion as assertion">
                            <div style="margin-bottom: 6px; padding: 6px; background: white; border-radius: 4px;">
                              <div style="font-weight: 600; margin-bottom: 4px;">
                                <i class="pi" [ngClass]="assertion.passed ? 'pi-check-circle' : 'pi-times-circle'"
                                   [style.color]="assertion.passed ? '#10b981' : '#ef4444'" style="margin-right: 4px;"></i>
                                {{ assertion.passed ? 'Verification Passed' : 'Verification Failed' }}
                              </div>

                              <div *ngIf="assertion.operator" style="display: grid; grid-template-columns: 1fr 1fr; gap: 4px; font-size: 11px;">
                                <div><strong>Type:</strong> {{ assertion.type }}</div>
                                <div><strong>Operator:</strong> {{ assertion.operator }}</div>
                                <div><strong>Expected:</strong> {{ assertion.expected }}</div>
                                <div><strong>Actual:</strong> {{ assertion.actual }}</div>
                                <div><strong>Status:</strong>
                                  <p-tag [value]="assertion.passed ? 'Passed' : 'Failed'"
                                    [severity]="assertion.passed ? 'success' : 'danger'"
                                    [style]="{'font-size': '10px', 'height': '18px'}">
                                  </p-tag>
                                </div>
                              </div>

                              <div *ngIf="assertion.column && !assertion.operator" style="display: grid; grid-template-columns: 1fr 1fr; gap: 4px; font-size: 11px;">
                                <div><strong>Type:</strong> {{ assertion.type }}</div>
                                <div><strong>Column:</strong> {{ assertion.column }}</div>
                                <div><strong>Expected:</strong> {{ assertion.expected }}</div>
                                <div><strong>Status:</strong>
                                  <p-tag [value]="assertion.passed ? 'Passed' : 'Failed'"
                                    [severity]="assertion.passed ? 'success' : 'danger'"
                                    [style]="{'font-size': '10px', 'height': '18px'}">
                                  </p-tag>
                                </div>
                                <div><strong>Total Validated:</strong> {{ assertion.totalValidated }}</div>
                                <div><strong>Pages Searched:</strong> {{ assertion.pagesSearched }}</div>
                                <div><strong>Execution Time:</strong> {{ assertion.executionTimeMs }}ms</div>
                                <div><strong>Pagination:</strong> {{ assertion.hasPagination ? 'Yes' : 'No' }}</div>
                              </div>

                              <!-- Response metrics (merged from Response tab) -->
                              <div *ngIf="assertion.totalValidated || assertion.totalMatched" style="margin-top: 6px; padding: 4px; background: #f1f5f9; border-radius: 3px; font-size: 11px;">
                                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 4px;">
                                  <div><strong>Total Validated:</strong> {{ assertion.totalValidated }}</div>
                                  <div><strong>Total Matched:</strong> {{ assertion.totalMatched }}</div>
                                  <div><strong>Match %:</strong> {{ assertion.matchPercentage || 'N/A' }}</div>
                                </div>
                              </div>

                              <div *ngIf="assertion.totalValidations" style="font-size: 11px; margin-top: 6px;">
                                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 4px; margin-bottom: 6px;">
                                  <div><strong>Total Validations:</strong> {{ assertion.totalValidations }}</div>
                                  <div><strong>Passed:</strong> {{ assertion.passedCount }} / {{ assertion.totalValidations }}</div>
                                </div>
                                <div *ngIf="assertion.failedValidations?.length > 0" style="padding: 4px; background: #fef2f2; border-radius: 3px; margin-bottom: 4px;">
                                  <div style="font-weight: 600; color: #991b1b; margin-bottom: 2px;">Failed:</div>
                                  <div *ngFor="let fv of assertion.failedValidations" style="padding: 2px 0; border-bottom: 1px solid #fecaca;">
                                    <span *ngFor="let cp of fv.validation?.columnPairs; let last = last">
                                      {{ cp.column }} {{ cp.operator }} "{{ cp.value }}"<span *ngIf="!last">, </span>
                                    </span>
                                    <span style="color: #991b1b;"> — {{ fv.reason }}</span>
                                  </div>
                                </div>
                                <div *ngIf="assertion.results && assertion.passedCount > 0" style="padding: 4px; background: #f0fdf4; border-radius: 3px;">
                                  <div style="font-weight: 600; color: #166534; margin-bottom: 2px;">Passed:</div>
                                  <div *ngFor="let r of assertion.results" [hidden]="!r.found" style="padding: 2px 0;">
                                    <span *ngFor="let cp of r.validation?.columnPairs; let last = last">
                                      {{ cp.column }} {{ cp.operator }} "{{ cp.value }}"<span *ngIf="!last">, </span>
                                    </span>
                                    <span [style.color]="r.found ? '#166534' : '#991b1b'">
                                      — {{ r.found ? 'Found (Row ' + r.rowIndex + ')' : r.reason }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div *ngIf="assertion.message" style="margin-top: 6px; padding: 4px; border-radius: 3px;"
                                [style.background]="assertion.passed ? '#f0fdf4' : '#fef2f2'"
                                [style.color]="assertion.passed ? '#166534' : '#991b1b'">
                                {{ assertion.message }}
                              </div>
                            </div>

                            <ng-container *ngIf="assertion.mismatchDetails && assertion.mismatchDetails.length > 0">
                              <div style="margin-top: 6px; padding: 6px; background: #fef2f2; border-radius: 4px; border-left: 3px solid #ef4444;">
                                <div style="font-weight: 600; color: #991b1b; margin-bottom: 4px;">
                                  <i class="pi pi-times-circle" style="margin-right: 4px;"></i>
                                  Mismatch Details
                                </div>
                                <div style="max-height: 80px; overflow-y: auto;">
                                  <div *ngFor="let mismatch of assertion.mismatchDetails" style="font-size: 11px; padding: 3px; border-bottom: 1px solid #fecaca;">
                                    Row {{ mismatch.row }}: Expected "{{ mismatch.expected }}", Found "{{ mismatch.actual }}"
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                          </ng-container>

                          <ng-template #parseError>
                            <p style="color: #ef4444; margin: 0;">Error parsing log data</p>
                          </ng-template>
                        </ng-container>

                        <ng-template #noLogText>
                          <p style="color: #6b7280; margin: 0;">No log data available</p>
                        </ng-template>
                      </ng-container>
                    </div>
                  </div>

                  <div class="detail-right">
                    <div class="section-title">Screenshot</div>
                    @if (step.screenshotUrl) {
                      <div class="screenshot-box" (click)="viewModel.viewScreenshot(step.screenshotUrl)">
                        <img [src]="step.screenshotFullUrl" alt="screenshot" style="width: 100%; height: 100%; object-fit: cover; border-radius: 6px;" />
                      </div>
                    } @else {
                      <div class="screenshot-box">No screenshot available</div>
                    }
                  </div>
                </div>
              </div>
            }
          }
        }
      </div>
    }
  </div>
</div>

<!-- Screenshot dialog (keep existing) -->
</div>
</div>

<!-- Screenshot dialog — outside card wrapper, appended to body for proper z-index and full backdrop -->
<p-dialog header="Screenshot" [visible]="viewModel.displayScreenshotDialog()" (visibleChange)="viewModel.displayScreenshotDialog.set($event)" [modal]="true"
    [style]="{width: '80vw', maxWidth: '1200px'}" [draggable]="false" [resizable]="false"
    [appendTo]="'body'" [blockScroll]="true">
    <div class="screenshot-container">
        <img [src]="viewModel.selectedScreenshot()" alt="Execution Screenshot" class="screenshot-image" />
    </div>
</p-dialog>